__turbopack_context__.v({
  "actions": "CategoriesTabs-module-scss-module__BDirCW__actions",
  "groupLink": "CategoriesTabs-module-scss-module__BDirCW__groupLink",
  "groupLinkMobile": "CategoriesTabs-module-scss-module__BDirCW__groupLinkMobile",
  "groupLinkMobileContainer": "CategoriesTabs-module-scss-module__BDirCW__groupLinkMobileContainer",
  "groupLinkMobileTitle": "CategoriesTabs-module-scss-module__BDirCW__groupLinkMobileTitle",
  "root": "CategoriesTabs-module-scss-module__BDirCW__root",
  "tabsLabel": "CategoriesTabs-module-scss-module__BDirCW__tabsLabel",
  "tabsList": "CategoriesTabs-module-scss-module__BDirCW__tabsList",
  "tabsRoot": "CategoriesTabs-module-scss-module__BDirCW__tabsRoot",
  "triggerButton": "CategoriesTabs-module-scss-module__BDirCW__triggerButton",
});
